module.exports = __webpack_public_path__ + "static/media/anke.9a7c140c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/decoration/img/anke.jpeg
// module id = 741
// module chunks = 0